import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveCrossHostRedirect } from '../../utils/siteHosts';

/** Full-page redirect when the current path belongs on the other host (storefront vs workspace). */
export function HostRedirect() {
  const location = useLocation();

  useEffect(() => {
    const target = resolveCrossHostRedirect(
      location.pathname,
      location.search,
      location.hash,
    );
    if (target) {
      window.location.replace(target);
    }
  }, [location.pathname, location.search, location.hash]);

  return null;
}
